/*
 * The booking statuses, as the API stores them.
 *
 * Was an Angular `constant` in app.js (step 34 of #614). Only bookingService, colourService and
 * the booking slide-out read it, and all three are plain modules/Vue components now.
 */
export default {
  QUOTING: 'quoting',
  HOLD: 'hold',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  ADMIN: 'admin',
  EXTERNAL: 'external',
  UNFUCKABLE: 'unfuckable',
}
